import config from './config';

export default {
  login(request) {
    const errors = {};

    if ( request.student_number == '' ) {
      errors.student_number = '教習生番号が入力されていません';
    } else {
      if ( ! request.student_number.match(/^[0-9]+$/) ) {
        errors.student_number = '教習生番号が正しくありません';
      }
    }

    if ( ! request.password ) {
      errors.password = 'パスワードが入力されていません';
    }

    return errors;
  },

  email_confirm(request) {
    const errors = {};

    if ( request.email == '' ) {
      errors.email = 'メールアドレスが入力されていません';
    } else {
      if ( ! request.email.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/) ) {
        errors.email = 'メールアドレスが正しくありません';
      }
    }
    return errors;
  },

  attend_confirm(request) {
    const errors = {};

    if ( request.code == '' ) {
      errors.code = '確認用コードが入力されていません';
    } else {
      if ( ! request.code.match(/^[0-9]{6}$/) ) {
        errors.code = '確認用コードが正しくありません';
      }
    }
    return errors;
  }
}
